<template>
  <span class="svg-ico-no-sign">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.46094 12.8281C2.46094 7.44591 6.82872 3.07812 12.2109 3.07812C17.5932 3.07812 21.9609 7.44591 21.9609 12.8281C21.9609 18.2103 17.5932 22.5781 12.2109 22.5781C6.82872 22.5781 2.46094 18.2103 2.46094 12.8281ZM12.2109 4.57812C7.65715 4.57812 3.96094 8.27434 3.96094 12.8281C3.96094 17.3819 7.65715 21.0781 12.2109 21.0781C16.7647 21.0781 20.4609 17.3819 20.4609 12.8281C20.4609 8.27434 16.7647 4.57812 12.2109 4.57812Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9513 5.99779C19.2442 6.29069 19.2442 6.76556 18.9513 7.05845L6.35129 19.6585C6.0584 19.9513 5.58352 19.9513 5.29063 19.6585C4.99774 19.3656 4.99774 18.8907 5.29063 18.5978L17.8906 5.99779C18.1835 5.7049 18.6584 5.7049 18.9513 5.99779Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
